module.exports = __webpack_public_path__ + "static/9-bf479e48faf4a34eb4a915072e4ab8eb.jpeg";